enum type {
  VIDEO = "VIDEO",
  IMAGE = "IMAGE",
  GIF = "GIF",
  AUDIO = "AUDIO",
}

export default type;
